import NewsArticles, { Article, Category } from "@/news_articles";
import axios, { AxiosResponse } from "axios";
import RssParser from "rss-parser";

export default class News {
  static st: number = 0;
  static list: Article[] = NewsArticles.all.map(a => new Article(a));

  public static async getList(category?: Category): Promise<Article[]> {
    const l = this.list.sort((a1, a2) => {
      return a2.id - a1.id;
    });

    if (category) {
      return l.filter(a => a.category === category);
    } else {
      return l;
    }
  }

  public static getById(id: number): Article | null {
    let res: Article | null = null;
    this.list.forEach(a => {
      if (a.id === id) {
        res = a;
        return;
      }
    });

    return res;
  }

  public static async getListFromRss() {
    const parser = new RssParser();
    const res = await fetch("https://recruit.stadium.co.jp/corpnewsfeed/");
    const feed = (await parser.parseString(
      await res.text(),
    )) as RssParser.Output<Article>;
    const rssItems: Article[] = [];

    feed.items
      .filter(
        item =>
          Array.isArray(item.categories) &&
          item.categories.some(cat => cat === "お知らせ" || cat === "イベント"),
      )
      .sort((a: RssParser.Item, b: RssParser.Item) => {
        return (
          (b.pubDate ? new Date(b.pubDate).getTime() : 0) -
          (a.pubDate ? new Date(a.pubDate).getTime() : 0)
        );
      })
      .forEach((item, id) => {
        if (item.pubDate && typeof item.pubDate === "string") {
          const timestamp = new Date(item.pubDate);
          rssItems.push({
            id,
            title: item.title || "",
            updatedAt: `${timestamp.getFullYear()}/${timestamp.getMonth() +
              1}/${timestamp.getDate()}`,
            category:
              Array.isArray(item.categories) &&
              item.categories.some(cat => cat === "お知らせ")
                ? Category.News
                : Category.Event,
            href: item.link,
            body: "",
          });
        }
      });

    return rssItems;
  }

  public static async filterPublished(list: Article[]): Promise<Article[]> {
    if (this.st === 0) {
      const r: AxiosResponse = await axios.get(
        "https://ntp-a4.nict.go.jp/cgi-bin/json",
      ); // 正確なJST
      this.st = r.data.st as number;
    }

    return list.filter(e => !e.revealAt || e.revealAt < this.st);
  }
}
